import Vue from 'vue'
import Router from 'vue-router'
import checkView from 'vue-check-view'

import Home from './views/Home.vue'

var VueTouch = require('vue-touch')
Vue.use(Router)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(checkView)


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
})
